import { RuntimeConfigValue } from '@/RuntimeConfigValue.ts';

export interface RuntimeConfig {
  readonly AppVersion: RuntimeConfigValue;
  readonly BuildDate: RuntimeConfigValue;
  readonly ApiBaseUrl: RuntimeConfigValue;
  readonly MsalEnabled: RuntimeConfigValue;
  readonly MsalClientId: RuntimeConfigValue;
  readonly MsalTenantId: RuntimeConfigValue;
  readonly MsalScopes: RuntimeConfigValue;
}

const getEnv = (key: keyof RuntimeConfig): RuntimeConfigValue => {
  return new RuntimeConfigValue(key, () => {
    const envKey = `VITE_${key
      .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
      .toUpperCase()}` as keyof ImportMetaEnv;
    const runtimeRaw = globalThis.APP_CONFIG as
      | Record<string, string | null | undefined>
      | undefined;
    const runtimeValue =
      runtimeRaw?.[key] ?? runtimeRaw?.[envKey as string] ?? null;
    const buildTimeValue = import.meta.env[envKey] ?? null;
    return runtimeValue || buildTimeValue || null;
  });
};

export const runtimeConfig: RuntimeConfig = {
  AppVersion: getEnv('AppVersion'),
  BuildDate: getEnv('BuildDate'),
  ApiBaseUrl: getEnv('ApiBaseUrl'),
  MsalEnabled: getEnv('MsalEnabled'),
  MsalClientId: getEnv('MsalClientId'),
  MsalTenantId: getEnv('MsalTenantId'),
  MsalScopes: getEnv('MsalScopes'),
};
